import { render, staticRenderFns } from "./TabPlanning.vue?vue&type=template&id=20bc3338"
import script from "./TabPlanning.vue?vue&type=script&lang=js"
export * from "./TabPlanning.vue?vue&type=script&lang=js"
import style0 from "./TabPlanning.vue?vue&type=style&index=0&id=20bc3338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports